import { getLodop } from '@/plugins/LodopFuncs.js';
import { cloneDeep } from 'lodash';
import { currentDate } from '@/utils/filter';

export default {
  data() {
    return {
      printShow: false,
      scriptList: {},
      review: false, // 是否开启打印预览
    }
  },
  methods: {
    // 打印处方
    printScript(form, type) {
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = false;
        return;
      }
      // console.log(form);
      // 将form的数据 深拷贝过来不影响原来的数据结构
      this.record = cloneDeep(form);
      // 在门诊功能时取当前医生名
      this.record.realName = this.$store.state.global.countInfo.realName;
      // 诊断的string
      this.record.inquiryInfo.diagnosisResultString = this.record.inquiryInfo.diagnosisResultList.map(item => item.diseaseName).join(',');
      this.record.inquiryInfo.doctorName = this.$store.state.global.countInfo.doctorName;
      // 诊断时间
      if (this.record.inquiryInfo.modle === 3) {
        // 补录时间
        this.record.inquiryInfo.clinicalTime = this.record.inquiryInfo.clinicalTime;
      } else {
        this.record.inquiryInfo.clinicalTime = currentDate;
      }
      if (type === 'print') {
        const { additionalList, examList, medicineDrugPrescriptionList, patientChineseDrugList, patientInfusionList, patientStickingDrugGroupList } = this.form;
        // 有没有填写数据 没有拦截做出提示
        if (additionalList.length === 0 &&
          examList.length === 0 &&
          medicineDrugPrescriptionList.length === 0 &&
          patientChineseDrugList.length === 0 &&
          patientInfusionList.length === 0 &&
          patientStickingDrugGroupList.length === 0) {
          this.$message({
            message: '请完善处方信息！',
            type: 'error',
          });
          return;
        }
        setTimeout(() => {
          if (medicineDrugPrescriptionList.length > 0) this.$refs.medicinePrint.print();
          if (patientChineseDrugList.length > 0) this.$refs.piecesPrint.print();
          if (patientInfusionList.length > 0) this.$refs.infusionPrint.print();
          if (patientStickingDrugGroupList.length > 0) this.$refs.applyPrint.print();
          if (examList.length > 0 || additionalList.length > 0) this.$refs.otherPrint.print();
        }, 100);
      }
      // 病历打印
      if (type === 'record') {
        this.$refs.recordPrint.print();
      }
      this.$notify({
        title: '提示',
        message: '正在打印请稍后...',
        type: 'success',
      });
    },
    // 打印输液卡
    printInfusionCard(form) {
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      this.record = cloneDeep(form);
      // 在门诊功能时取当前医生名
      this.record.realName = this.$store.state.global.countInfo.realName;
      // 诊断的string
      this.record.inquiryInfo.diagnosisResultString = this.record.inquiryInfo.diagnosisResultList.map(item => item.diseaseName).join(',');
      this.record.inquiryInfo.doctorName = this.$store.state.global.countInfo.doctorName;
      // 诊断时间
      if (this.record.inquiryInfo.modle === 3) {
        // 补录时间
        this.record.inquiryInfo.clinicalTime = this.record.inquiryInfo.clinicalTime;
      } else {
        this.record.inquiryInfo.clinicalTime = currentDate;
      }
      this.$notify({
        title: '提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.$refs.infusionCardPrint.print();
    },
  },
};
